import Component from 'vue-class-component';
import Vue from 'vue';
@Component
export default class NotFoundComponent extends Vue {
    public async goToRoot() {
        await this.$router.push({ name: 'crm-all-deals' });
    }
}
